import Dashboard from './Dashboard';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast, Slide } from 'react-toastify';

export default function Admin() {  
    const [ token, setToken ] = useState(null);
    const [ username, setUsername ] = useState("");
    const [ password, setPassword ] = useState("");

    async function login() {
        axios.post(( ( window.API_ENDPOINT || "/api/" ) || window.API_ENDPOINT )+"login", {username, password})
            .then(res=>{
                toast.success("Login successful");
                setToken(res.data.token);
            }).catch(r=>{
                toast.error("Invalid credentials");
            })
    }

    useEffect(()=>{
        if (!token) return;
        axios.get(( ( window.API_ENDPOINT || "/api/" ) || window.API_ENDPOINT )+"valid", {headers: {Authorization: "Bearer "+token}})
            .catch(r=>{
                console.log("token invalid")
                setToken(null);
            })
    }, [token])

    if (!token) return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                transition={Slide}
            />
            <div className="login">
            <label htmlFor="username">Username: </label>
            <input id="username" name="username" value={username} onChange={e=>setUsername(e.target.value)} /><br/>
            <label htmlFor="password">Password: </label>
            <input id="password" name="password" type="password" value={password} onChange={e=>setPassword(e.target.value)} /><br/>
            <button onClick={login}>Login</button>
        </div>
        </>
        
    )

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                transition={Slide}
            />
            <Dashboard
                token={token}
                setToken={setToken}
                toast={toast}
            />
        </>
    );
}